import { get } from 'lodash';
import { validateDecimalSchema } from 'utils/commonSchema';
import * as yup from 'yup';
import { ProductTypeList, ComplimentAreaList } from './enum';

import { validateTextSchema } from 'utils/commonSchema';

const textFieldMax = 4000;
const textFieldMin = 1;

export const fileTypeMatch = (attachments: string[]) => new RegExp('\\.(' + attachments.join('|') + ')$', 'i');

const complaintSchema = yup.object({
  productType: yup.string().oneOf(ProductTypeList).required(),

  compDescription: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

  desiredOutcome: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

  compType: yup.string().oneOf(['sales', 'claims', 'financialHardshipApp']).required(),

  compCategory: yup.array().min(1).max(2).required('Please select 2 categories').required(),

  amountInDispute: validateDecimalSchema({ errorMessage: 'Please enter a dollar figure' }),

  files: yup
    .mixed()
    .nullable()
    .test('fileSize', `fileSize error`, function (files = []) {
      const context = this.options.context;
      if (!Array.isArray(files)) return true;
      const totalFileSize = files.reduce((prev: number, current: File) => prev + current.size, 0);
      const maxFileSizeLimitAlt = get(window, '_CMS_.MAX_FILE_UPLOAD_SIZE_IN_MB', 0); // temporary : validationContext is not working
      const maxFileSizeLimit = get(context, 'maxFileSizeLimit', maxFileSizeLimitAlt);
      const isValid = totalFileSize === 0 || totalFileSize <= maxFileSizeLimit * 1024 * 1024;
      if (!isValid)
        return this.createError({
          message: `Maximum file size limit of ${maxFileSizeLimit}MB has been exceeded, please remove some files.`,
        });
      return isValid;
    })
    .test('fileType', `This file type is not allowed, please attach a different document type`, function (files = []) {
      if (!Array.isArray(files)) return true;
      const fileNameData: string[] = files.map((file: File) => file.name);
      const allowedFileTypes: string[] = get(window, '_CMS_.ALLOWED_FILE_EXTENSIONS', []);

      let count = 0;

      fileNameData.forEach((value) => {
        const schema = yup.string().matches(fileTypeMatch(allowedFileTypes), 'Invalid file type');
        if (!schema.isValidSync(value)) count++;
        return schema.isValidSync(value);
      });

      return count === 0;
    }),
});

const complimentOrFeedbackSchema = yup.object({
  productType: yup.string().oneOf([...ProductTypeList, '']),

  compType: yup.string().oneOf(['sales', 'claims']).required(),

  compArea: yup.string().oneOf(ComplimentAreaList).required(),

  compDescription: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),
});

const validationSchema = (lodgement?: string) => {
  switch (lodgement) {
    case 'Complaint':
      return complaintSchema;

    default:
      return complimentOrFeedbackSchema;
  }
};

export default validationSchema;
